import { useQueuedModal } from '#shared/lib/modals'

interface ModalsLayoutProps {
  children: React.ReactNode
}

export default function ModalsLayout({ children }: ModalsLayoutProps) {
  const queuedModal = useQueuedModal()

  return (
    <>
      {children}
      {queuedModal?.content}
    </>
  )
}
